import { Observable } from "./observable";
import unsubscribe from "./unsubscribe";

function merge() {
  for (var _len = arguments.length, observables = new Array(_len), _key = 0; _key < _len; _key++) {
    observables[_key] = arguments[_key];
  }

  if (observables.length === 0) {
    return Observable.from([]);
  }

  return new Observable(function (observer) {
    var completed = 0;
    var subscriptions = observables.map(function (input) {
      return input.subscribe({
        error: function error(_error) {
          observer.error(_error);
          unsubscribeAll();
        },
        next: function next(value) {
          observer.next(value);
        },
        complete: function complete() {
          if (++completed === observables.length) {
            observer.complete();
            unsubscribeAll();
          }
        }
      });
    });

    var unsubscribeAll = function unsubscribeAll() {
      subscriptions.forEach(function (subscription) {
        return unsubscribe(subscription);
      });
    };

    return unsubscribeAll;
  });
}

export default merge;